import { RuntimeConfiguration } from '@/configuration';

interface EventParams {
  action: string;
  category: string;
  label: string;
  value?: number;
}

export const GA_TRACKING_ID: string | undefined = RuntimeConfiguration.GOOGLE_TAG_MANAGER_ID;

export const pageview = (url: string, title: string): void => {
  if (GA_TRACKING_ID) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      page_title: title
    });
  }
};

export const event = ({ action, category, label, value }: EventParams): void => {
  if (GA_TRACKING_ID) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value
    });
  }
};
